import React from 'react';
import { Phone, Clipboard, Video, Edit, Send, ArrowRight } from 'lucide-react';

const HowItWorks = ({ onBookCall }) => {
  const steps = [
    {
      number: '01',
      icon: Phone,
      title: 'Discovery Call',
      description: 'We discuss your vision, goals, and production requirements'
    },
    {
      number: '02',
      icon: Clipboard,
      title: 'Production Planning',
      description: 'Detailed planning of shots, schedule, and creative direction'
    },
    {
      number: '03',
      icon: Video,
      title: 'Filming Day',
      description: 'Professional filming in our studio or at your chosen location'
    },
    {
      number: '04',
      icon: Edit,
      title: 'Post Production',
      description: 'Expert editing, color grading, and sound mixing'
    },
    {
      number: '05',
      icon: Send,
      title: 'Final Delivery',
      description: 'Optimized content delivered for all your platforms'
    }
  ];

  return (
    <section className="relative z-10 py-24 sm:py-32 border-t border-white/[0.06]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="mb-14 sm:mb-20">
          <p className="ltv-eyebrow text-red-500 mb-4">04 — Process</p>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05]">
            Concept to delivery,
            <br />
            <span className="text-gray-500">we handle everything.</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-5">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="group relative rounded-2xl border border-white/[0.08] bg-white/[0.03] hover:bg-white/[0.06] hover:border-red-500/30 p-6 transition-all duration-300">
                <span className="font-display text-5xl font-bold text-white/[0.06] group-hover:text-red-500/20 transition-colors block mb-6">
                  {step.number}
                </span>
                <div className="w-10 h-10 rounded-xl bg-red-600/10 flex items-center justify-center mb-5 group-hover:bg-red-600/20 transition-colors">
                  <Icon className="h-5 w-5 text-red-500" />
                </div>
                <h3 className="font-display text-lg font-bold text-white mb-2">{step.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{step.description}</p>
              </div>
            );
          })}
        </div>
        <div className="mt-12">
          <button
            onClick={onBookCall}
            className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-500 text-white text-base font-semibold px-8 py-4 rounded-full shadow-2xl shadow-red-600/30 transition-all hover:scale-[1.03]"
          >
            Book a Call
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
